import {
  Box,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EventIcon from "@mui/icons-material/Event";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import calendar from "../../assets/icon/calendarblack.png";

export const DateCp = ({ label, value, setFormatDate }) => {
  const [startDate, setStartDate] = useState(value ? dayjs(value) : null);

  useEffect(() => {
    if (value) {
      setStartDate(dayjs(value));
    } else {
      setStartDate(null);
    }
  }, [value]);
  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={startDate}
          onChange={(newValue) => {
            if (newValue) {
              setFormatDate(newValue.format("YYYY-MM-DD"));
              setStartDate(newValue);
            }
          }}
          InputLabelProps={{
            sx: {
              background: "#fff",
              borderRadius: 1,
              cursor: "pointer",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "20px" },
              fontWeight: 500,
            },
          }}
          InputProps={{
            style: {
              // height: '40px',
              // background:"yellow"
            },
            sx: {
              background: "#fff",
              borderRadius: 1,
              cursor: "pointer",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "20px" },
              fontWeight: 500,
            },
          }}
          format="DD-MM-YYYY"
          label={label}
          slots={{ openPickerIcon: CalendarMonthIcon }}
          slotProps={{
            textField: {
              fullWidth: true,
              placeholder: "Date",
              size: "small",
              InputProps: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end">
                      <Box
                        component="img"
                        src={calendar}
                        alt="calendar icon"
                        sx={{ width: 20, height: 20, cursor: "pointer" }}
                      />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: {
                  background: "#fff",
                  borderRadius: 1,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
              },
              InputLabelProps: {
                sx: {
                  background: "#fff",
                  borderRadius: 1,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
              },
            },
            openPickerIcon: {
              sx: { color: "#000" },
            },
          }}
        />
      </LocalizationProvider>
    </React.Fragment>
  );
};
